<template>
  <Modal class="max-w-[500px]!">
    <Modal.Title>Get technical comparison analysis report</Modal.Title>
    <Modal.Body>
      <FlaggedMatchBody :infringement="infringement" />
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button variant="primary" @click="handleCreate">Create report</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button } from '@dacr/library'

import FlaggedMatchBody from './FlaggedMatchBody.vue'
import { useFlaggedMatch, type FlaggedInfringement } from './useFlaggedMatch'

const props = defineProps<{ infringement: FlaggedInfringement }>()

const { handleCreate } = useFlaggedMatch(props.infringement)
</script>
